// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionSignatureEntity from './entities/petition-signature.json';
import petitionSignatureMenu from '../pages/petition-signature/menu.json';
import petitionSignatureFullForm from '../pages/petition-signature/forms/full.json';
import petitionSignatureContextForm from '../pages/petition-signature/forms/context.json';
import petitionSignatureMiniForm from '../pages/petition-signature/forms/mini.json';
import petitionSignatureLookupForm from '../pages/petition-signature/forms/lookup.json';
import petitionSignatureTableView from '../pages/petition-signature/views/table.json';
import petitionSignatureCardsView from '../pages/petition-signature/views/cards.json';
import petitionSignatureCalendarView from '../pages/petition-signature/views/calendar.json';
import petitionSignatureDashboardView from '../pages/petition-signature/views/dashboard.json';

/** Тип запису «Підпис» зі сторінками пакета: меню, форми та подання з pages/petition-signature/. */
export const petitionSignatureDefinition: IRecordTypeDefinition = {
  ...petitionSignatureEntity,
  views: assembleViewSet({
      table: petitionSignatureTableView,
      cards: petitionSignatureCardsView,
      calendar: petitionSignatureCalendarView,
      dashboard: petitionSignatureDashboardView,
  }),
  form: petitionSignatureFullForm,
  forms: { full: petitionSignatureFullForm, context: petitionSignatureContextForm, mini: petitionSignatureMiniForm, lookup: petitionSignatureLookupForm },
  menu: petitionSignatureMenu,
} as IRecordTypeDefinition;
